import { useEffect } from 'react'

import { removeCall, setCall } from '@liveHelper/models/persistence/call'
import { callDataSelector, useStore } from '@liveHelper/models/store'

/** Persists call id when it changes. */
export function usePersistCall() {
  const callData = useStore(callDataSelector)

  useEffect(() => {
    if (callData?.id) {
      setCall(callData.id)
    } else {
      removeCall()
    }
  }, [callData?.id])
}
